import React from 'react';
import { motion } from 'framer-motion';
import { BadgeDivider } from './Badge';
const TILES = [{
  img: 'https://cdn.magicpatterns.com/uploads/qDTPeaPjRE1VaV2XvADhZ7/VU_TwistedTiki_2026-03-28_StageSetup.jpg',
  alt: 'Virtually Unknown stage setup at Twisted Tiki',
  caption: 'Twisted Tiki · stage setup',
  rotate: '-2deg'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/q1zFLdkEFJPBiEbMxWwfZL/VU_HeroPhoto_Source.jpg',
  alt: 'Virtually Unknown performing poolside',
  caption: 'Poolside session',
  rotate: '-1deg'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/pWNHGN6xq393HDSJpQC4Ar/VU_BandPhoto_PinellasPark.jpg',
  alt: 'Virtually Unknown together in Pinellas Park',
  caption: 'Pinellas Park · the crew',
  rotate: '1.5deg'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/s3xotkjniQsVgMFcg2kFTC/VU_BandCartoon_Group.png',
  alt: 'Cartoon illustration of the Virtually Unknown band members',
  caption: 'The crew, animated',
  rotate: '-1.5deg'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/3GZqU4vSvcRksp2dmvEH5V/VU_TwistedTiki_2026-04-25_Soundcheck.jpg',
  alt: 'Virtually Unknown at soundcheck at Twisted Tiki',
  caption: 'Twisted Tiki · soundcheck',
  rotate: '2deg'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/4Cmso8zmN7XB3Ju27TaMqJ/VU_diner_B_W.jpg',
  alt: 'Black and white Virtually Unknown band photo in a diner car',
  caption: 'All aboard · black & white',
  rotate: '1deg'
}];
export function Photos() {
  return <section id="photos" className="relative w-full bg-[var(--vu-black)] py-20 px-5 overflow-hidden grain" data-id="element-74" data-mp="z1xjr2sxdch">
      <div className="relative z-10 max-w-5xl mx-auto text-center" data-id="element-75" data-mp="3sauz0wrp0s3m">
        <p className="font-cond uppercase tracking-[0.4em] text-[var(--vu-gold)] text-xs mb-2" data-id="element-76" data-mp="3ndladjc4okgu">
          The Wall
        </p>
        <h2 className="font-display uppercase text-[var(--vu-cream)] text-5xl sm:text-6xl leading-none" data-id="element-77" data-mp="opxm8fbynsfi">
          Photos
        </h2>
        <BadgeDivider label="✶" data-id="element-78" data-mp="12t4r0sjr5kvc" />

        <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 gap-6" data-id="element-79" data-mp="12u6anleu3foo">
          {TILES.map((tile, index) => <motion.figure key={tile.img} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.06
        }} style={{
          rotate: tile.rotate
        }} className="self-start bg-[var(--vu-cream)] p-2 pb-4 border-2 border-[var(--vu-black)] shadow-[5px_5px_0_0_var(--vu-navy)] hover:rotate-0 hover:z-10 transition-transform" data-id="element-80" data-mp="17ry10aztytqr" data-mpi={index}>
              <div className="border border-[var(--vu-black)]/20 bg-[var(--vu-cream)]" data-id="element-81" data-mp="f42bbq8oi23h">
                <img src={tile.img} alt={tile.alt} className="block w-full h-auto max-w-full object-contain" loading="lazy" data-id="element-82" data-mp="f5vf8xrwq87s" />
              </div>
              <figcaption className="mt-2 font-cond uppercase tracking-widest text-[10px] text-[var(--vu-black)]/60" data-id="element-83" data-mp="3tzcd7ktup2go">
                {tile.caption}
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}